module.exports = __webpack_public_path__ + "static/media/icons_Bilan Cervical MDT.3adadc10.svg";